
import { computed, defineComponent, ref } from 'vue'

export default defineComponent({
  inheritAttrs: false,
  props: {
    datePickerTitle: {
      type: String,
      default: 'Выбор даты',
    },
  },
  setup(props, { attrs, emit }) {
    const datePickerActive = ref(false)
    const formattedDate = computed(() => {
      const modelValue = attrs.modelValue
      return modelValue && modelValue instanceof Date ? new Date(modelValue).toLocaleDateString() : undefined
    })

    const updateModelValue = (date: Date | undefined) => {
      if (datePickerActive.value) datePickerActive.value = false
      emit('update:model-value', date)
    }

    return {
      datePickerActive,
      formattedDate,
      updateModelValue,
    }
  },
})
